import React, {useCallback, useRef, useState} from 'react';
import {Job, JobHandle} from 'components/customer/Job/Job';
import CBCDialog from 'shared/components/ConfirmationDialog/CBCDialog';
import Footer, {
    CloseEventType,
} from 'shared/components/ConfirmationDialog/Footer';
import styled from 'styled-components';
import {size} from 'shared/Breakpoints';

export const useJobDialog = (isEdit = false) => {
    const jobRef = useRef<JobHandle>(null);
    const [show, setShow] = useState(false);

    const openJobDialog = useCallback(() => setShow(true), []);
    const closeJobDialog = useCallback(() => setShow(false), []);

    const handleClose = useCallback(async (event: CloseEventType) => {
        switch (event) {
            case CloseEventType.CANCEL:
                setShow(false);
                break;
            case CloseEventType.APPLY:
                await jobRef.current?.submit();
                break;
        }
    }, []);

    const jobDialog = (
        <CBCDialog
            display={show}
            title={isEdit ? 'Edit Job Details' : 'New Job'}
            width="40vw"
            maxHeight="90vh"
            fullScreenOnMobile
            onHide={closeJobDialog}
            footer={
                <JobDialogFooter
                    onClose={handleClose}
                    yesButtonText={isEdit ? 'Save Job' : 'Create Job'}
                    noButtonText="Cancel"
                />
            }>
            {show ? (
                <Job
                    ref={jobRef}
                    isHomePage={true}
                    noNavigate={isEdit}
                    isNew={!isEdit}
                    onSaved={closeJobDialog}
                />
            ) : null}
        </CBCDialog>
    );

    return {openJobDialog, jobDialog};
};

const JobDialogFooter = styled(Footer)`
    @media (max-width: ${size.md}px) {
        flex-direction: column-reverse;
    }
`;
